import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ProjectRoutingModule } from './project-routing.module';
import { SettingsModule } from '../../shared/services/settings/settings.module';

import { ProjectDefaultRoutingComponent } from './project-default-routing/project-default-routing.component';
import { CreateProjectComponent } from './home/create-project/create-project.component';
import { ProjectHomeComponent } from './home/project-home/project-home.component';
import { ProjectScoreHomeComponent } from './scores/project-score-home/project-score-home.component';
import { ProjectInboxHomeComponent } from './inbox/project-inbox-home/project-inbox-home.component';
import { ProjectInboxSentComponent } from './inbox/project-inbox-sent/project-inbox-sent.component';
import { ProjectInboxReceivedComponent } from './inbox/project-inbox-received/project-inbox-received.component';
import { ProjectEngagementHomeComponent } from './engagement/project-engagement-home/project-engagement-home.component';
import { ProjectActionHomeComponent } from './action/project-action-home/project-action-home.component';
import { ProjectHuddleHomeComponent } from './huddle/project-huddle-home/project-huddle-home.component';
import { ProjectSettingsHomeComponent } from './settings/project-settings-home/project-settings-home.component';
import { SharedModule } from "../../shared/components/shared.module";
import { AllHuddlesComponent } from './huddle/all-huddles/all-huddles.component';
import { AllActionPlansComponent } from './huddle/all-action-plans/all-action-plans/all-action-plans.component';
import { AllSuggestionsComponent } from './huddle/all-suggestions/all-suggestions/all-suggestions.component';
import { AllSpotlightsComponent } from './huddle/all-spotlights/all-spotlights/all-spotlights.component';
import { HuddleSummaryComponent } from './huddle/summary/huddle-summary/huddle-summary.component';
import { ProjectInteractionSettingsHomeComponent } from './settings/project-interaction-settings-home/project-interaction-settings-home.component';
import { ProjectChannelSettingsHomeComponent } from './settings/project-channel-settings-home/project-channel-settings-home.component';
import { ProjectUserAccessSettingsHomeComponent } from './settings/project-user-access-settings-home/project-user-access-settings-home.component';
import { ProjectRequestSettingsHomeComponent } from './settings/project-request-settings-home/project-request-settings-home.component';
import { ProjectActionSettingsHomeComponent } from './settings/project-action-settings-home/project-action-settings-home.component';
import { ProjectDatasetsSettingsHomeComponent } from './settings/project-datasets-settings-home/project-datasets-settings-home.component';
import { ProjectActionAgeingHomeComponent } from './action/project-action-ageing-home/project-action-ageing-home.component';
import { ProjectActionTatHomeComponent } from './action/project-action-tat-home/project-action-tat-home.component';
import { ActionAgeingActionableIssueCountComponent } from './action/action-ageing-actionable-issue-count/action-ageing-actionable-issue-count.component';
import { ActionAgeingActionableIssueSummaryComponent } from './action/action-ageing-actionable-issue-summary/action-ageing-actionable-issue-summary.component';
import { ActionAgeingActionableIssueTrendChartComponent } from './action/action-ageing-actionable-issue-trend-chart/action-ageing-actionable-issue-trend-chart.component';
import { ActionAgeingActionableIssueBarChartComponent } from './action/action-ageing-actionable-issue-bar-chart/action-ageing-actionable-issue-bar-chart.component';
import { ActionTatOverallComponent } from './action/project-action-tat-home/components/action-tat-overall/action-tat-overall.component';
import { ActionTatHierarchyComponent } from './action/project-action-tat-home/components/action-tat-hierarchy/action-tat-hierarchy.component';
import { ActionTatHistogramComponent } from './action/project-action-tat-home/components/action-tat-histogram/action-tat-histogram.component';
import { ActionTatCategoryChartsComponent } from './action/project-action-tat-home/components/action-tat-category-charts/action-tat-category-charts.component';
import { SearchComponent } from 'src/app/shared/components/search/search.component';
import { ProjectActionSummaryHomeComponent } from './action/project-action-summary-home/project-action-summary-home.component';
import { ActionSummaryOverallComponent } from './action/project-action-summary-home/components/action-summary-overall/action-summary-overall.component';
import { ActionSummaryHierarchyComponent } from './action/project-action-summary-home/components/action-summary-hierarchy/action-summary-hierarchy.component';
import { ActionSummaryTrendChartComponent } from './action/project-action-summary-home/components/action-summary-trend-chart/action-summary-trend-chart.component';
import { ActionSummaryBarChartComponent } from './action/project-action-summary-home/components/action-summary-bar-chart/action-summary-bar-chart.component';
import { LtmsPaginationComponent } from 'src/app/shared/components/ltms-pagination/ltms-pagination.component';
import { ProjectEngagementPageViewComponent } from './engagement/project-engagement-page-view/project-engagement-page-view.component';
import { ProjectScoreQuickInsightsComponent } from './scores/project-score-quick-insights/project-score-quick-insights.component';
import { ProjectScoreQuickInsightsPerformersComponent } from './scores/project-score-quick-insights-performers/project-score-quick-insights-performers.component';
import { ProjectScoreQuickInsightsCohortsComponent } from './scores/project-score-quick-insights-cohorts/project-score-quick-insights-cohorts.component';
import { ProjectOutboxHomeComponent } from './outbox/project-outbox-home/project-outbox-home.component';
import { WordcloudComponent } from './inbox/wordcloud/wordcloud.component';
import { OutboxDetailPanelComponent } from './outbox/outbox-detail-panel/outbox-detail-panel.component';
import { OutboxRequestCreationComponent } from "./outbox/requests/outbox-request-creation/outbox-request-creation.component";
import { OutboxChannelSelectionPanelComponent } from './outbox/outbox-channel-selection-panel/outbox-channel-selection-panel.component';
import { OutboxMultiRequestCreationComponent } from "./outbox/requests/outbox-request-creation/outbox-multi-request-creation/outbox-multi-request-creation.component";
import { OutboxSingleRequestCreationComponent } from "./outbox/requests/outbox-request-creation/outbox-single-request-creation/outbox-single-request-creation.component";
import { OutboxMultiRequestUploadHistoryComponent } from './outbox/requests/outbox-request-creation/outbox-multi-request-upload-history/outbox-multi-request-upload-history.component';


//conversation setup component
import { LitmusIntractionQuestionnaireComponent } from './settings/project-interaction-settings-home/sub-components/litmus-intraction-questionnaire/litmus-intraction-questionnaire.component';
import { LitmusIntractionPagesComponent } from './settings/project-interaction-settings-home/sub-components/litmus-intraction-pages/litmus-intraction-pages.component';
import { LitmusIntractionLanguagesComponent } from './settings/project-interaction-settings-home/sub-components/litmus-intraction-languages/litmus-intraction-languages.component';
import { LitmusIntractionGroupsComponent } from './settings/project-interaction-settings-home/sub-components/litmus-intraction-groups/litmus-intraction-groups.component';
import { LitmusIntractionCustomComponent } from './settings/project-interaction-settings-home/sub-components/litmus-intraction-custom/litmus-intraction-custom.component';
import { LitmusIntractionOffersComponent } from './settings/project-interaction-settings-home/sub-components/litmus-intraction-offers/litmus-intraction-offers.component';
import { LitmusIntractionCampaignComponent } from './settings/project-interaction-settings-home/sub-components/litmus-intraction-campaign/litmus-intraction-campaign.component';
import { LitmusIntractionNavigationComponent } from './settings/project-interaction-settings-home/sub-components/litmus-intraction-navigation/litmus-intraction-navigation.component';
import { CreateNewQuestionComponent } from './settings/project-interaction-settings-home/sub-components/create-new-question/create-new-question.component';
import { QuillModule } from 'ngx-quill';
import { LitmusIntractionDraftComponent } from "./settings/project-interaction-settings-home/sub-components/litmus-intraction-draft/litmus-intraction-draft.component";

@NgModule({
    imports: [
        CommonModule,
        ProjectRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        NgbModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        QuillModule.forRoot({
            modules: {
                syntax: false,
                toolbar: [
                    [{ 'font': [] }],
                    [{ 'size': ['small', false, 'large', 'huge'] }],
                    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                    ['blockquote', 'code-block'],
                    [{ 'header': 1 }, { 'header': 2 }], // custom button values
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }], // superscript/subscript
                    [{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent
                    [{ 'direction': 'rtl' }], // text direction
                    [{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
                    [{ 'align': [] }],
                    ['clean'], // link and image, video
                ]
            }
        }),
        LitmusIntractionDraftComponent,
        DragDropModule,
        SettingsModule,
        ProjectDefaultRoutingComponent,
        CreateProjectComponent,
        ProjectHomeComponent,
        ProjectScoreHomeComponent,
        ProjectInboxHomeComponent,
        ProjectInboxSentComponent,
        ProjectInboxReceivedComponent,
        ProjectEngagementHomeComponent,
        ProjectActionHomeComponent,
        ProjectHuddleHomeComponent,
        ProjectSettingsHomeComponent,
        AllHuddlesComponent,
        AllActionPlansComponent,
        AllSuggestionsComponent,
        AllSpotlightsComponent,
        HuddleSummaryComponent,
        ProjectInteractionSettingsHomeComponent,
        ProjectChannelSettingsHomeComponent,
        ProjectUserAccessSettingsHomeComponent,
        ProjectRequestSettingsHomeComponent,
        ProjectActionSettingsHomeComponent,
        ProjectDatasetsSettingsHomeComponent,
        ProjectActionAgeingHomeComponent,
        ProjectActionTatHomeComponent,
        ActionAgeingActionableIssueCountComponent,
        ActionAgeingActionableIssueSummaryComponent,
        ActionAgeingActionableIssueTrendChartComponent,
        ActionAgeingActionableIssueBarChartComponent,
        ActionTatOverallComponent,
        ActionTatHierarchyComponent,
        ActionTatHistogramComponent,
        ActionTatCategoryChartsComponent,
        SearchComponent,
        ProjectActionSummaryHomeComponent,
        ActionSummaryOverallComponent,
        ActionSummaryHierarchyComponent,
        ActionSummaryTrendChartComponent,
        ActionSummaryBarChartComponent,
        LtmsPaginationComponent,
        ProjectEngagementPageViewComponent,
        ProjectScoreQuickInsightsComponent,
        ProjectScoreQuickInsightsPerformersComponent,
        ProjectScoreQuickInsightsCohortsComponent,
        ProjectOutboxHomeComponent,
        OutboxDetailPanelComponent,
        OutboxChannelSelectionPanelComponent,
        OutboxRequestCreationComponent,
        OutboxSingleRequestCreationComponent,
        OutboxMultiRequestCreationComponent,
        OutboxMultiRequestUploadHistoryComponent,
        WordcloudComponent,
        LitmusIntractionQuestionnaireComponent,
        LitmusIntractionPagesComponent,
        LitmusIntractionLanguagesComponent,
        LitmusIntractionGroupsComponent,
        LitmusIntractionCustomComponent,
        LitmusIntractionOffersComponent,
        LitmusIntractionCampaignComponent,
        LitmusIntractionNavigationComponent,
        CreateNewQuestionComponent
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class ProjectsModule { }


export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}
